import { useEffect } from 'react';

export const useMountEffect = (
  fun: React.EffectCallback //eslint-disable-next-line react-hooks/exhaustive-deps
) => useEffect(fun, []);
